import * as XLSX from "xlsx";

/** x-data-spreadsheet JSON <-> SheetJS workbook converters. */
export function stox(wb) {
  const out = [];
  wb.SheetNames.forEach((name) => {
    const o = { name, rows: {} };
    const ws = wb.Sheets[name];
    if (ws && ws["!ref"]) {
      const aoa = XLSX.utils.sheet_to_json(ws, { raw: false, header: 1 });
      aoa.forEach((r, i) => {
        const cells = {};
        r.forEach((c, j) => { if (c !== null && c !== undefined) cells[j] = { text: String(c) }; });
        o.rows[i] = { cells };
      });
    }
    out.push(o);
  });
  return out;
}

export function xtos(sdata) {
  const wb = XLSX.utils.book_new();
  (sdata || []).forEach((xws, idx) => {
    const aoa = [];
    const formulas = [];
    Object.entries(xws.rows || {}).forEach(([ri, row]) => {
      if (ri === "len" || !row || !row.cells) return;
      Object.entries(row.cells).forEach(([ci, cell]) => {
        const r = +ri, c = +ci;
        if (!aoa[r]) aoa[r] = [];
        const t = cell.text ?? "";
        if (typeof t === "string" && t.startsWith("=")) {
          aoa[r][c] = "";
          formulas.push({ r, c, f: t.slice(1) });
        } else {
          const n = t !== "" && !isNaN(t) ? Number(t) : t;
          aoa[r][c] = n;
        }
      });
    });
    const ws = XLSX.utils.aoa_to_sheet(aoa.length ? aoa : [[]]);
    formulas.forEach(({ r, c, f }) => {
      ws[XLSX.utils.encode_cell({ r, c })] = { t: "n", f };
    });
    XLSX.utils.book_append_sheet(wb, ws, xws.name || `Sheet${idx + 1}`);
  });
  return wb;
}
